export const InventoryActionTypes = {
    API_RESPONSE_SUCCESS: '@@inventory/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@inventory/API_RESPONSE_ERROR',
    READ_ALL_INVENTORY_REQUEST: '@@inventory/READ_ALL_INVENTORY_REQUEST',
    CREATE_INVENTORY_REQUEST: '@@inventory/CREATE_INVENTORY_REQUEST',
    UPDATE_INVENTORY_REQUEST: '@@inventory/UPDATE_INVENTORY_REQUEST',
    DELETE_INVENTORY_REQUEST: '@@inventory/DELETE_INVENTORY_REQUEST',
    RESET_STATE: '@@inventory/RESET_STATE',
    RESET_ALL_ERRORS: '@@inventory/RESET_ALL_ERRORS',
};
